import $ from 'jquery';

$(() => {
  $('#keuzes a.js-remove-choice').on('click', (e) => {
    const optionCount = $('#keuzes .nested-fields:visible').size();

    if (optionCount < 3) {
      alert('Een peiling moet tenminste 2 keuzes hebben');
      e.preventDefault();
      e.stopPropagation();
    }
  });
});
